export default __webpack_public_path__ + "static/media/sch2.05f42748.jpg";